import { useState, useEffect, useContext } from 'react';
import {ErrorContext} from '../Contexts/ErrorContext'
import IncidenceService from '../Services/IncidenceService';
import {extractErrorMessage} from '../Services/RequestService';

export const useVehicleIncidences = (vehicleId) => {
    const [vehiclesIncidences, setVehiclesIncidences] = useState([]);
    const token = localStorage.getItem("token");
    const {setError, success} = useContext(ErrorContext);

    const addVehicleIncidence = async (incidence) => {
        try {
            await IncidenceService.addIncidence(token, incidence);
            await getVehicleIncidences()
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const getVehicleIncidences = async () => {
        try {
            const vehiclesIncidenceResponse = await IncidenceService.getVehicleIncidence(token, vehicleId);
            setVehiclesIncidences(vehiclesIncidenceResponse.data);
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const editVehicleIncidence = async (incidence, id) => {
        try {
            await IncidenceService.editIncidence(token, incidence, id);
            await getVehicleIncidences()
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const deleteVehicleIncidence = async (incidence) => {
        try {
            await IncidenceService.deleteIncidence(token, incidence.id);
            await getVehicleIncidences()
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    useEffect(() => {
        getVehicleIncidences()
    }, []);

    return [vehiclesIncidences, addVehicleIncidence, editVehicleIncidence, deleteVehicleIncidence];
}


// WEBPACK FOOTER //
// ./src/Hooks/useVehicleIncidences.js